import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class AlmaPayService {

    create(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/alma`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    cancel(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/alma/cancel/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    view(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/alma/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }


    viewAll() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/alma`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterAll(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/alma/filter`,data , {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }



}

export default new AlmaPayService()